import React from 'react';

export const ConsoleContext = React.createContext({});
